import { z } from 'zod';
export const userPermissionAssignSchema = z.object({
    permissionId: z.coerce.number().int().positive('Geçerli bir izin ID giriniz'),
    granted: z.boolean().optional().default(true),
});
export const userPermissionsBulkSchema = z.object({
    permissions: z.array(z.object({
        permissionId: z.coerce.number().int().positive(),
        granted: z.boolean().optional().default(true),
    })),
});
//# sourceMappingURL=permission.schema.js.map